export const EXPERT_MEMBERSHIP_PATH = "/expert/membership";

export const EXPERT_MEMBERSHIP_VERIFICATION_TAB = "VERIFICATION_QUEUE";

/** @deprecated Legacy join-requests tab removed; links open membership verification queue. */
export const EXPERT_MEMBERSHIP_JOIN_TAB = EXPERT_MEMBERSHIP_VERIFICATION_TAB;

export const EXPERT_MEMBERSHIP_JOIN_PATH = EXPERT_MEMBERSHIP_PATH;

export function expertMembershipApprovalPath(tab?: string): string {
  const params = tab ? `?tab=${encodeURIComponent(tab)}` : "";
  return `${EXPERT_MEMBERSHIP_PATH}${params}`;
}

export const EXPERT_MEMBERSHIP_APPROVAL_PATH = expertMembershipApprovalPath();
